// extracted by mini-css-extract-plugin
module.exports = {"search-input-root":"SearchInput_search-input-root__2UX5d","loader-wrapper":"SearchInput_loader-wrapper__1EK7x"};